export default __webpack_public_path__ + "static/media/bg_master_07.73e107b7.jpg";